import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-payment-notification',
  templateUrl: './payment-notification.component.html',
  styleUrls: ['./payment-notification.component.scss']
})
export class PaymentNotificationComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<PaymentNotificationComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: { message: any}) { }

  ngOnInit(): void {
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
}
